import { Badge, IconButton, Tooltip } from '@mui/material';
import { useState } from 'react';
import { useLocales } from 'src/locales';
import {
  onNewNotification,
  onNotificationDelete,
  onNotificationUpdate,
} from 'src/socket/listeners/notification.listeners';
import { useSocketEvent } from 'src/socket/use-event';
import Iconify from '../../components/iconify';
import { NotificationsDrawer } from './NotificationsDrawer';
import { useNotification } from './shared/useNotification';
import { useNotificationsQuery } from './shared/useNotificationsQuery';

export function NotificationsPopover() {
  const [open, setOpen] = useState(false);
  const { notify } = useNotification();
  const { translate } = useLocales();
  const { unreadCount, refetchNotifications } = useNotificationsQuery();

  useSocketEvent(
    onNewNotification(async ({ notification }) => {
      await refetchNotifications();
      notify(notification);
    }),
  );

  useSocketEvent(
    onNotificationUpdate(async () => {
      await refetchNotifications();
    }),
  );

  useSocketEvent(
    onNotificationDelete(async () => {
      await refetchNotifications();
    }),
  );

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Tooltip
        placement="bottom"
        arrow
        title={translate('shared.labels.notifications')}
      >
        <IconButton
          color="inherit"
          onClick={handleOpen}
          sx={{
            width: 36,
            height: 36,
            borderRadius: 1,
            ...(open && {
              bgcolor: (theme) => theme.palette.action.selected,
            }),
          }}
        >
          <Badge badgeContent={unreadCount} color="error">
            <Iconify icon="tabler:bell" />
          </Badge>
        </IconButton>
      </Tooltip>

      <NotificationsDrawer open={open} onClose={handleClose} />
    </>
  );
}
